import { MessageDescriptor } from 'react-intl';

import { mainCheckTaxForRectificationCode } from './checkTaxCode';
import messages from './messages';

export const getErrorMessageBaiCode = (
  code: string,
  codeExtra?: string | number
): MessageDescriptor | undefined => {
  const { code265, code1072 } = mainCheckTaxForRectificationCode(
    code,
    codeExtra
  );

  if (code265) {
    return messages.error265;
  }

  if (code1072) {
    return messages.error1072;
  }

  return undefined;
};
